'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Transmitter = function () {
  function Transmitter(options) {
    _classCallCheck(this, Transmitter);

    this.global = options.global;
    this.integrationId = options.integrationId;
    this.integrationInstanceId = options.integrationInstanceId;
  }

  _createClass(Transmitter, [{
    key: 'messageToEmarsys',
    value: function messageToEmarsys(eventName, data) {
      this.global.parent.postMessage(JSON.stringify(this.setMessageSource(this.compileMessage(eventName, data))), '*');
    }
  }, {
    key: 'messageToService',
    value: function messageToService(eventName, data, targetInstanceId) {
      this.messageToEmarsys('proxy', {
        event: eventName,
        envelope: data,
        integrationInstanceId: targetInstanceId
      });
    }
  }, {
    key: 'compileMessage',
    value: function compileMessage(eventName, data) {
      return {
        event: eventName,
        data: data
      };
    }
  }, {
    key: 'setMessageSource',
    value: function setMessageSource(message) {
      return Object.assign({}, message, {
        source: {
          integration_id: this.integrationId,
          integration_instance_id: this.integrationInstanceId
        }
      });
    }
  }]);

  return Transmitter;
}();

module.exports = Transmitter;


/*****************
 ** WEBPACK FOOTER
 ** /home/runner/work/emarsys-integration-js/emarsys-integration-js/~/emarsys-integration-client/dist/comm/transmitter.js
 ** module id = 2
 ** module chunks = 0 1
 **/